import { Dayjs } from "dayjs"
import { BillStatus, IBill } from "./bill.types"
import { formatBalance } from "@/helpers/moneyHelpers"

export class Bill implements IBill {
  constructor(
    public id: number,
    public status: BillStatus,
    public charges: number,
    public balance: number,
    public juniferBillNumber: string,
    public isSuperseded: boolean,
    public isDirtyBill: boolean,
    public isFinalBill: boolean,
    public isConsolidatedBill: boolean,
    public isDeleted: boolean,
    public billAcceptedDate?: Dayjs,
    public billCreatedDate?: Dayjs,
    public dueDate?: Dayjs,
    public periodFrom?: Dayjs,
    public periodTo?: Dayjs,
  ) {}

  get chargesFormatted(): string {
    return formatBalance(this.charges)
  }
}
